export default "__VITE_ASSET__$Nh4KyOA__"